// core
import React from 'react';
import { Link } from 'react-router-dom'

// settings + utils
import Settings from 'config.js';
import Auth from 'services/Auth.js';
import API from 'utils/API.js';
import CSV from 'utils/CSV.js';

// lib
import Page from 'pages/shared/Page';
import Spinner from 'components/shared/Spinner';

// shared
import PageHeader from 'components/shared/PageHeader';
import ButtonsToolbar from 'components/shared/ButtonsToolbar';
import FiltersToolbar from 'components/shared/filters/FiltersToolbar';
import SortingToolbar from 'components/shared/SortingToolbar';

import MainHeading from 'components/shared/MainHeading';
import PageDataWrapper from 'pages/shared/PageDataWrapper.js';

class MailingOverviewPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      status: {
        fetching: false
      },

      errors: [],

      mailings: [],
      listsById: {}
    };
  }

  componentDidMount() {
    this.setState(({
      fetching: true
    }));

    // get lists
    API.call('GET', Settings.V3_API_URL + '/recipient-lists', {}, (response, error) => {
      if (error) {
        this.setState({
          fetching: false,

          error: error.message + ' while getting lists'
        });

        return false;
      }

      let listsById = {};
      response.data.lists.forEach((list) => {
        listsById[list.id] = list;
      });
      this.setState({
        listsById: listsById
      });

      // get queues
      API.call('GET', Settings.V3_API_URL + '/mailing-queues', {}, (response, error) => {
        if (error) {
          this.setState({
            fetching: false,

            error: error.message + ' while getting queues'
          });

          return false;
        }

        this.setState({
          fetching: false,

          mailings: response.data.queues
        });
      });
    });
  }

  render() {
    let mailingsContent = [];

    let mailingsByDate = {
      today: [],
      yesterday: [],
      last_3_days: [],
      last_week: [],
      etc: []
    };

    this.state.mailings.forEach((mailing) => {
      const createdAt = new Date(mailing.created_at);

      const age = Math.floor(((new Date()).getTime() - createdAt.getTime()) / (1000*60*60*24));

      if (age == 0) {
        mailingsByDate.today.push(mailing);
      }
      if (age == 1) {
        mailingsByDate.yesterday.push(mailing);
      }
      if (age > 1 && age <= 3) {
        mailingsByDate.last_3_days.push(mailing);
      }
      if (age > 3 && age <= 7) {
        mailingsByDate.last_week.push(mailing);
      }
      if (age > 7) {
        mailingsByDate.etc.push(mailing);
      }
    });

    console.dir(mailingsByDate);

    mailingsContent = [
      {
        label: 'Oggi',
        name: 'today'
      },
      {
        label: 'Ieri',
        name: 'yesterday'
      },
      {
        label: 'Ultimi 3 giorni',
        name: 'last_3_days'
      },
      {
        label: 'Ultima settimana',
        name: 'last_week'
      },
      {
        label: 'Etc.',
        name: 'etc'
      }
    ].map((time) => {
      if (mailingsByDate[time.name].length) {
        return (
          <div>
            <h4>{time.label} ({mailingsByDate[time.name].length})</h4>
            {
              mailingsByDate[time.name].reverse().map((mailing) => {
                return (
                  <div style={{padding: '10px 0'}}>
                    <h4><Link to={'/marketing/mailings/' + mailing.id + '/view/'}>{mailing.name}</Link></h4>

                    <p className="mb-0">
                      {
                        mailing.lists.map((listId) => {
                          const list = this.state.listsById[listId];
                          if (!list) {
                            return '';
                          }

                          return (
                            <div>
                              <i className="far fa-stream" /> {list.name} · {list.schools.length} scuole · {list.teachers.length} insegnanti ·  {list.emails.length} destinatari hardcodati
                            </div>
                          );
                        })
                      }
                    </p>

                    <p><small className="text-secondary mt-1">#{mailing.id}, il: {mailing.created_at}</small></p>
                  </div>
                );
              })
            }
          </div>
        );
      }
    });

    return (
      <div>
        <PageHeader>
          <ButtonsToolbar
            related={[
              {
                label: 'Crea nuovo',
                href: '/marketing/mailings/new/',
                type: 'add'
              }
            ]}
          />
          <MainHeading
            icon="fa fa-mail-bulk"
            title="Mailing"
            descr=""
          />
        </PageHeader>

        <PageDataWrapper
          appData={this.props.appData}

          data={{
            label: 'Tutti i mailing',
            descr: '(' + this.state.mailings.length + ')',
            onExport: this.state.mailings.length && 0 ? () => {
              alert('export!');
            } : null
          }}
          status={{
            fetching: this.state.fetching,
            errors: this.state.errors
          }}
        >
          {mailingsContent}
        </PageDataWrapper>
      </div>
    );
  }
}

export default MailingOverviewPage;


// WEBPACK FOOTER //
// ./src/pages/marketing/mailings/MailingOverviewPage.js